import { Component, OnInit,Input } from '@angular/core';
import { PageContentService } from 'src/services/pagecontent.service';

@Component({
  selector: 'app-lang',
  templateUrl: './lang.component.html',
  styleUrls: ['./lang.component.scss']
})
export class LangComponent implements OnInit {
    @Input() dividers: boolean = true;
    @Input() iconSize: string = 'sm';
    @Input() iconColor: string = '';
  public flags = [
    { name:'English', image: 'assets/images/flags/gb.svg' },
    { name:'German', image: 'assets/images/flags/de.svg' },
    { name:'French', image: 'assets/images/flags/fr.svg' },
    { name:'Russian', image: 'assets/images/flags/ru.svg' },
    { name:'Turkish', image: 'assets/images/flags/tr.svg' }
  ]
  public flag:any;
    public siteConfigList: any[];
    isScreenReaderCheck: boolean;
  constructor(public pageservice: PageContentService) { }

  ngOnInit() {
    this.flag = this.flags[0]; 
    this.siteConfigList = [];
    this.getSiteConfig();
  }
  getSiteConfig() {
    this.pageservice.getSiteconfig().subscribe(result => {
        
        if (result != null) {
            this.siteConfigList = result;
            this.isScreenReaderCheck = result.isScreenReader;
        }
    });
}
  public changeLang(flag){
    this.flag = flag;
  }

}
